import { render, staticRenderFns } from "./MedienUpload.vue?vue&type=template&id=bce876f4&scoped=true"
import script from "./MedienUpload.vue?vue&type=script&lang=js"
export * from "./MedienUpload.vue?vue&type=script&lang=js"
import style0 from "./MedienUpload.vue?vue&type=style&index=0&id=bce876f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce876f4",
  null
  
)

export default component.exports